import { Referential } from '@/features/shared/types';

export enum REGISTER_SUBSCRIBE_FORM {
  termsAndContractValidated = 'termsAndContractValidated',
  contactFirstName = 'contactFirstName',
  contactLastName = 'contactLastName',
  countryCodeId = 'countryCodeId',
  companyEmail = 'companyEmail',
  phoneNumber = 'phoneNumber',
  postCode = 'postCode',
  street = 'street',
  email = 'email',
  city = 'city',
  name = 'name',
}

export type RegisterSubscribeForm = {
  termsAndContractValidated: boolean;
  contactFirstName: string;
  contactLastName: string;
  countryCodeId: string;
  companyEmail: string;
  phoneNumber: string;
  postCode: string;
  street: string;
  email: string;
  name: string;
  city: string;
};

export type GetcCuntryCodesReferential = {
  countryCodes: Referential[];
};
